import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useReduxStore } from '../../../hooks/useReduxStore';
import { GetTicketByIdAction, UpdateTicketStatusAction } from '../../../store/Sagas/Admin/adminSupportSaga';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export default function SupportDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const { ticket, ticketId: ticketIdFromNav } = location?.state || {};
  const { getState, dispatch } = useReduxStore();
  const { selectedTicket, loading } = getState('ADMIN_SUPPORT');
// console.log("ticketId---------",ticketId)
  useEffect(() => {
    if (!ticket && ticketIdFromNav) {
      dispatch(GetTicketByIdAction({ticketId: ticketIdFromNav}));
    }
  }, [ticket, ticketIdFromNav, dispatch]);

  const updateStatus = (status) => {
    const id = ticket?._id || ticketIdFromNav;
    dispatch(UpdateTicketStatusAction({ ticketId: id, status }));
  };

  const detail = ticket || selectedTicket;
  if (loading || !detail) {
    return (
      <div className="p-6">
        <div className="flex items-center justify-center h-64 text-white">Loading ticket...</div>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center">
        <button onClick={() => navigate('/Admin/Dashboard/Support')} className="flex items-center gap-2 text-gray-400 hover:text-white">
          <ArrowLeftIcon className="h-5 w-5" /> Back to Tickets
        </button>
        <div className="text-sm text-gray-400">Ticket #{detail._id}</div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-blueGray border-2 border-borderGray rounded-lg p-6">
          <h3 className="text-xl font-semibold text-white mb-4">Ticket Details</h3>
          <div className="space-y-3 text-white">
            <div><span className="text-gray-400">Subject:</span> {detail.subject}</div>
            <div><span className="text-gray-400">Status:</span> <span className="capitalize">{detail.status}</span></div>
            <div><span className="text-gray-400">Priority:</span> <span className="capitalize">{detail.priority || '-'}</span></div>
            <div><span className="text-gray-400">Created:</span> {new Date(detail.createdAt).toLocaleString()}</div>
          </div>
        </div>
        <div className="bg-blueGray border-2 border-borderGray rounded-lg p-6">
          <h3 className="text-xl font-semibold text-white mb-4">User</h3>
          <div className="space-y-3 text-white">
            <div><span className="text-gray-400">Name:</span> {detail.user?.name || '-'}</div>
            <div><span className="text-gray-400">Email:</span> {detail.user?.email || '-'}</div>
          </div>
        </div>
      </div>

      <div className="bg-blueGray border-2 border-borderGray rounded-lg p-6">
        <h3 className="text-xl font-semibold text-white mb-4">Description</h3>
        <p className="text-white whitespace-pre-wrap">{detail.description || '-'}</p>
      </div>

      {/* <div className="flex items-center gap-3">
        <span className="text-gray-400">Update Status:</span>
        <select value={detail.status} onChange={(e)=>updateStatus(e.target.value)} className="px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white">
          <option value="open">Open</option>
          <option value="in_progress">In Progress</option>
          <option value="closed">Closed</option>
        </select>
      </div> */}
    </div>
  );
}


